import Component from "react-pure-render/component";
import React from "react";
import Isvg from "react-inlinesvg";
import moment from "moment";
import Griddle from "griddle-react";
import Tooltip from "rc-tooltip";
import Modal from "../components/modal.react";
import InputCustom from "../components/inputCustom.react";

import { addNotificationsForInvalidFields } from "../lib/validationWeb";

class ActionComponent extends Component {
  openRemovePagesListModal = () => {
    const {
      openRemovePagesListModal
    } = this.props.metadata.customComponentMetadata;
    const slug = this.props.rowData.slug;
    openRemovePagesListModal(slug);
  };

  openEditPagesListModal = () => {
    const {
      openEditPagesListModal
    } = this.props.metadata.customComponentMetadata;
    const slug = this.props.rowData.slug;
    openEditPagesListModal(slug);
  };

  render() {
    const {
      onDeletePageList,
      onEditPageList
    } = this.props.metadata.customComponentMetadata;
    const row = this.props.rowData;
    return (
      <div>
        <Tooltip
          placement="bottom"
          trigger={["click", "hover"]}
          overlay={
            <div className="popover">
              <a onTouchTap={this.openRemovePagesListModal}>usuń</a>
              <br />
              <a onTouchTap={this.openEditPagesListModal}>edytuj</a>
            </div>
          }
          getTooltipContainer={() => document.getElementById("wrapper")}
        >
          <div className="icon-table link" />
        </Tooltip>
      </div>
    );
  }
}

export default class Table extends Component {
  static propTypes = {
    actions: React.PropTypes.object.isRequired
  };

  constructor(props) {
    super(props);
  }

  onRowClick = (row, e) => {
    if (e.target.className !== "icon-table link") {
      const { history } = this.props;
      history.pushState(
        "/pagesLists/:slug",
        `/pagesLists/${row.props.data.slug}`,
        {}
      );
    }
  };

  onChangeSort = field => {
    if (field === "name") {
      const {
        actions,
        notificationSystem,
        pagesLists: {
          pagesLists: {
            search: pagesListsSearch,
            meta: pagesListsMeta,
            sort: pagesListsSort
          }
        }
      } = this.props;
      if (field === "when") {
        field = "whenOccured";
      }
      actions.setPagesListsPaginationPage(0);
      let isDirectionAscending = pagesListsSort.isDirectionAscending;
      if (field === pagesListsSort.field) {
        isDirectionAscending = !isDirectionAscending;
      }
      actions.setSortPagesLists(field, isDirectionAscending);
      this.getPagesLists();
    }
  };

  getPagesLists = () => {
    const {
      actions,
      notificationSystem,
      pagesLists: { pagesLists: { meta: pagesListsMeta, sort: pagesListsSort } }
    } = this.props;
    actions.clearForm("pagesLists", "createPagesList");
    actions
      .getPagesLists(pagesListsMeta, pagesListsSort)
      .then(({ error, payload }) => {
        if (error) {
          addNotificationsForInvalidFields(payload, notificationSystem);
        }
      });
  };

  openRemovePagesListModal = uid => {
    const { actions } = this.props;
    actions.setIsRemovePagesListModalVisible(uid);
  };

  closeRemovePagesListModal = () => {
    const { actions } = this.props;
    actions.setIsRemovePagesListModalVisible(false);
  };

  removePagesList = () => {
    const {
      actions,
      pagesLists: {
        pagesLists: { isRemoveModalVisible, entities: pagesLists }
      },
      notificationSystem
    } = this.props;
    actions
      .removePagesList(pagesLists.getIn([isRemoveModalVisible, "uid"]))
      .then(({ error, payload }) => {
        if (error) {
          addNotificationsForInvalidFields(payload, notificationSystem);
        } else {
          this.getPagesLists();
        }
      });
    actions.setIsRemovePagesListModalVisible(false);
  };

  openEditPagesListModal = uid => {
    const { actions } = this.props;
    actions.setIsEditPagesListModalVisible(uid);
  };

  closeEditPagesListModal = () => {
    const { actions } = this.props;
    actions.setIsEditPagesListModalVisible(false);
  };

  updatePagesList = () => {
    const {
      actions,
      pagesLists: { pagesLists: { isEditModalVisible, entities: pagesLists } },
      notificationSystem
    } = this.props;
    let data = {
      name: pagesLists.getIn([isEditModalVisible, "name"])
    };
    if (pagesLists.getIn([isEditModalVisible, "slug"]) !== isEditModalVisible) {
      data.slug = pagesLists.getIn([isEditModalVisible, "slug"]);
    }
    actions
      .updatePagesList(data, pagesLists.getIn([isEditModalVisible, "uid"]))
      .then(({ error, payload }) => {
        if (error) {
          addNotificationsForInvalidFields(payload, notificationSystem);
        } else {
          this.getPagesLists();
        }
      });
    actions.setIsEditPagesListModalVisible(false);
  };

  render() {
    const {
      config,
      actions,
      tableWidth,
      tableHeight,
      pagesLists: {
        pagesLists: {
          isRemoveModalVisible,
          isEditModalVisible,
          loading,
          entities: pagesLists,
          meta: { currentPage, limit },
          sort
        }
      },
      locales: { locales: { defaultLocale } }
    } = this.props;

    let columnMetadata = [
      {
        columnName: "index",
        displayName: "Lp.",
        cssClassName: "table-unsortable",
        visible: true
      },
      {
        columnName: "name",
        displayName: "Nazwa",
        cssClassName: "table-unsortable",
        visible: true
      },
      {
        columnName: "actions",
        displayName: "Akcje",
        visible: true,
        cssClassName: "data-table-file table-unsortable",
        customComponent: ActionComponent,
        customComponentMetadata: {
          openRemovePagesListModal: this.openRemovePagesListModal,
          openEditPagesListModal: this.openEditPagesListModal
        }
      }
    ];

    let data = [];
    let index = 0;

    if (pagesLists) {
      pagesLists.forEach(function(pageList) {
        pageList = pageList.toJS();
        index++;
        pageList.index = index + currentPage * limit;
        data = data.concat(pageList);
      });
    }

    const inputCustomProps = {
      feature: "pagesLists",
      actions: actions,
      entity: pagesLists.get(isEditModalVisible),
      uid: isEditModalVisible
    };

    return (
      <div>
        <Griddle
          results={data}
          columnMetadata={columnMetadata}
          tableClassName="data-table"
          useGriddleStyles={false}
          columns={["index", "name", "actions"]}
          onRowClick={this.onRowClick}
          enableSort={false}
          enableInfiniteScroll={false}
          showPager={false}
          bodyHeight={tableHeight}
          resultsPerPage={100}
          useExternal={true}
          externalChangeSort={this.onChangeSort}
          externalSortColumn={sort.field}
          externalSortAscending={sort.isDirectionAscending}
          externalSetPage={() => {}}
          externalSetFilter={() => {}}
          externalSetPageSize={() => {}}
          externalMaxPage={() => {}}
          externalCurrentPage={() => {}}
          noDataMessage={loading ? "trwa ładowanie danych..." : "Brak danych"}
          sortAscendingComponent={
            <Isvg className="fa fa-sort-asc" src="/assets/img/icon_sort.svg" />
          }
          sortDescendingComponent={
            <Isvg className="fa fa-sort-desc" src="/assets/img/icon_sort.svg" />
          }
        />

        {isRemoveModalVisible && (
          <Modal
            closeModalAction={this.closeRemovePagesListModal}
            enterAction={this.removePagesList}
            handleKeyDownEvent={true}
          >
            <div className="row center-xs">
              <h3>Uwaga!</h3>
              <p>Czy na pewno usunąć?</p>
              <button className="error" onTouchTap={this.removePagesList}>
                Tak
              </button>
              <button
                className="info"
                onTouchTap={this.closeRemovePagesListModal}
              >
                Nie
              </button>
            </div>
          </Modal>
        )}

        {isEditModalVisible && (
          <Modal
            closeModalAction={this.closeEditPagesListModal}
            enterAction={this.updatePagesList}
            handleKeyDownEvent={true}
          >
            <div className="row center-xs">
              <h3>Edytuj tytuł wpisu</h3>
              <InputCustom field={["name"]} {...inputCustomProps} />
              <InputCustom field={["slug"]} {...inputCustomProps} />
              <button className="error" onTouchTap={this.updatePagesList}>
                Tak
              </button>
              <button
                className="info"
                onTouchTap={this.closeEditPagesListModal}
              >
                Nie
              </button>
            </div>
          </Modal>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/browser/pagesLists/table.react.js